import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const type = getCurrentTypePreference()
    setTimeout(() => {
      this.dispatch("changed", { detail: { type: type }, bubbles: true })
    }, 0);
  }
  paper() {
    this.dispatch("changed", { detail: { type: "paper" } })
  }

  online() {
    this.dispatch("changed", { detail: { type: "online" } })
  }

  arena() {
    this.dispatch("changed", { detail: { type: "arena" } })
  }
}
